import React, { useState, useEffect, useRef } from "react";
import DOMPurify from "dompurify";

const OptimizedReadMore = ({ children, maxLines = 3 }) => {
  const [expanded, setExpanded] = useState(false);
  const [clamped, setClamped] = useState(true);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      const { clientHeight, scrollHeight } = contentRef.current;
      if (scrollHeight > clientHeight) {
        setClamped(true);
      } else {
        setClamped(false);
      }
    }
  }, [children]);

  // Sanitize using DOMPurify — removes XSS payloads AND extension-injected elements
  const sanitizeText = (text) => {
    // First let DOMPurify clean all XSS threats
    const clean = DOMPurify.sanitize(text, {
      USE_PROFILES: { html: true },
      FORBID_TAGS: ["script", "iframe", "object", "embed", "form"],
      FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
    });

    // Then remove extension-injected elements like before
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = clean;
    tempDiv.querySelectorAll("#click_to_dial_wrapper").forEach((el) => el.remove());

    return tempDiv.innerHTML;
  };

  return (
    <div style={{ position: "relative", maxWidth: "100%" }}>
      <div
        ref={contentRef}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: expanded ? "unset" : maxLines,
          overflow: "hidden",
          wordBreak: "break-word",
          transition: "all 0.3s ease-in-out",
          maxHeight: expanded ? "none" : `${maxLines * 1.5}em`,
        }}
        dangerouslySetInnerHTML={{ __html: sanitizeText(children) }}
      ></div>

      {clamped && (
        <button
          onClick={() => setExpanded(!expanded)}
          style={{
            color: "blue",
            cursor: "pointer",
            background: "none",
            border: "none",
            padding: 0,
            marginTop: "5px",
            display: "inline-block",
          }}
        >
          {expanded ? "Show Less" : "Read More"}
        </button>
      )}
    </div>
  );
};

export default OptimizedReadMore;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/OptimizedReadMore.js